import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { FaCheckCircle, FaLinkedin, FaExclamationTriangle } from 'react-icons/fa';
import Swal from 'sweetalert2';

const OnboardingLinkedInCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Processing LinkedIn authorization...');

  useEffect(() => {
    const handleLinkedInCallback = async () => {
      try {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const tokenID = urlParams.get('tokenID');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        if (error) {
          setStatus('error');
          setMessage(`LinkedIn authorization failed: ${errorDescription || error}`);
          return;
        }

        if (!tokenID) {
          setStatus('error');
          setMessage('No authorization token received from LinkedIn');
          return;
        }

        // Get stored user info
        const tempUserId = localStorage.getItem('tempUserId');
        const tempUserType = localStorage.getItem('tempUserType');
        const tempFormData = localStorage.getItem('tempFormData');

        if (!tempUserId || !tempFormData) {
          setStatus('error');
          setMessage('Session expired. Please start the onboarding process again.');
          return;
        }

        // Save form data and userId for Step 5 before clearing temp data
        const formDataObj = JSON.parse(tempFormData);
        formDataObj.userId = tempUserId; // Add userId to form data
        localStorage.setItem('onboardingFormData', JSON.stringify(formDataObj));

        // LinkedIn authorization successful
        setStatus('success');
        setMessage('LinkedIn account connected successfully!');

        // Clean up temporary data
        localStorage.removeItem('tempUserId');
        localStorage.removeItem('tempUserType');
        localStorage.removeItem('tempFormData');

        // Show success message and redirect to Step 5
        setTimeout(() => {
          Swal.fire({
            icon: 'success',
            title: 'LinkedIn Connected!',
            text: 'Your LinkedIn account has been connected successfully. You can now complete your setup.',
            confirmButtonText: 'Continue Setup'
          }).then(() => {
            // Redirect back to onboarding form at Step 5 (Complete step)
            navigate('/onboarding?step=5');
          });
        }, 2000);

      } catch (error) {
        console.error('Error processing LinkedIn callback:', error);
        setStatus('error');
        setMessage('An error occurred while processing your LinkedIn authorization. Please try again.');
      }
    };

    handleLinkedInCallback();
  }, [navigate]);

  const renderContent = () => {
    switch (status) {
      case 'processing':
        return (
          <div className="text-center">
            <Spinner animation="border" variant="primary" className="mb-3" />
            <h4>Processing LinkedIn Authorization</h4>
            <p className="text-muted">{message}</p>
          </div>
        );

      case 'success':
        return (
          <div className="text-center">
            <FaCheckCircle size={64} className="text-success mb-3" />
            <h4 className="text-success">LinkedIn Connected Successfully!</h4>
            <p className="text-muted">{message}</p>
            <p className="text-muted">Redirecting you to the final step...</p>
          </div>
        );

      case 'error':
        return (
          <div className="text-center">
            <FaExclamationTriangle size={64} className="text-danger mb-3" />
            <h4 className="text-danger">Authorization Failed</h4>
            <p className="text-muted">{message}</p>
            <button 
              className="btn btn-primary mt-3"
              onClick={() => navigate('/onboarding')}
            >
              Try Again
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow">
            <Card.Body className="p-5">
              {renderContent()}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OnboardingLinkedInCallback;

